import axios from '../axios-init';

export const getDoctorProduct = params => {
    return axios.post(`/products/getProductListByCurrentUser`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getInventory = params => {
    return axios.post(`/products/getProductList`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const addProduct = params => {
    return axios.post(`/products/saveOrUpdateById`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getDoctorProductList = params => {
    return axios.post(`/products/getDoctorProductList`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getProductById = params => {
    return axios.post(`/products/getProductAndDiscount`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getUserInventory = params => {
    return axios.post(`/inbound/getUserInventoryList`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getZeroInventory = params => {
    return axios.post(`/inbound/getUserInventoryZeroList`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const reportInventory = params => {
    return axios.post(`/inventoryReport/saveOrUpdateReportInfo`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getInventoryByProduct = params => {
    return axios.post(`/inventoryReport/getInventoryListByProduct`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getInventoryReportList = params => {
    return axios.post(`/inventoryReport/getInventoryReportList`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const editReportStatus = params => {
    return axios.post(`/inventoryReport/changeInventoryReportStausById`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const editFBM = params => {
    return axios.post(`/fbm/saveOrUpdateFbmInfo`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getFBM = params => {
    return axios.post(`/fbm/getFbmList`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getNotClaimed = params => {
    return axios.post(`/confirmWarehouse/getNotClaimedList`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getProductFBM = params => {
    return axios.post(`/fbm/getProductFBM`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const deleteProduct = params => {
    return axios.post(`/products/deleteProduct`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getStockHistory = params => {
    return axios.post(`/stockOperationLog/getStockOperationLogList`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getSizeList = params => {
    return axios.post(`/boxsizes/selectOptions`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getServiceList = params => {
    return axios.post(`/serviceFee/selectOptions`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

// 仓库产品池接口  start
export const addProductTemplate = params => {
    return axios.post(`/products_template/saveOrUpdateTemplateById`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getProductTemplateById = params => {
    return axios.post(`/products_template/getProductTemplateById`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getDistributedDoctorName = params => {
    return axios.post(`/products_template/getDistributedDoctorName`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const deleteProductTemplate = params => {
    return axios.post(`/products_template/deleteProductTemplate`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getProductTemplateListByCondition = params => {
    return axios.post(`/products_template/getProductListByCondition`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const distributeProductTempate = params => {
    return axios.post(`/products_template/distribute`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

// 仓库产品池接口  end



// WEBPACK FOOTER //
// ./src/api/inventoryService.js